import { homeComponent } from './home.component';

export const homeStateName = 'app.home';

export const homeState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: homeStateName,
    url: '/',
    component: homeComponent.name,
    data: { requiresAuth: true },
    resolve: {
      isAdmin: ($state, userService) => {
        if (userService.isAdmin()) {
          $state.go('app.admin');
          return true;
        }
        return false;
      }
    }
  });
};
